/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

/**
 * Flips once `accessible_module_keys` has been backfilled for every pre-existing admin (#3080)
 * and that backfill has been verified in this environment.
 *
 * Until then, an admin who has never had their module grant touched can carry an empty list for
 * no reason other than the backfill not having reached them yet (#3088's column defaults every
 * row to `[]`). Treating that the same as a deliberate "revoke every module" would sign every
 * restaurant-level admin out of the whole Admin App the moment enforcement goes live. Failing open
 * on an empty list — matching the access those admins already have today — is the safer state
 * while the backfill is in flight; a genuinely empty grant made through the module access form
 * stops being distinguishable from "not backfilled yet" until this flips, which is the accepted
 * cost of not locking out working admins in the meantime.
 *
 * Set per environment at build time: `REACT_APP_EMPTY_GRANT_MEANS_NO_ACCESS=true` turns it on, and
 * anything else, including unset, keeps it off. Turn it on only where the backfill is verified.
 * Once every environment has it on, delete this file and both places that read it — the branch in
 * `useModuleAccess` and the one in `resolveLandingPath` (appModules.js).
 */
export const EMPTY_GRANT_MEANS_NO_ACCESS = process.env.REACT_APP_EMPTY_GRANT_MEANS_NO_ACCESS === 'true'
